
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        color: '#FFF',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 'normal',
        borderTop: '1px solid rgba(200, 200, 200, 0.32)',
        borderBottom: '1px solid rgba(200, 200, 200, 0.32)',
    },

    '& .MuiDialogTitle-root': {
        color: '#FFF',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: '0.975rem',
        fontWeight: 500,
        lineHeight: 'normal',
    },

    '& .MuiDialogActions-root': {
        padding: theme.spacing(2),
    },

    '& .MuiDialog-paper': {
        borderRadius: '8px',
        background: '#13161D',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        color: '#FFF',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 'normal',
    },
}));

const PreferenceOption = ({ active, title, coin, description, onClick }) => {
    return (
        <div
            onClick={onClick}
            style={{
                border: active
                    ? '1px solid #1DAFA1'
                    : '1px solid rgba(200, 200, 200, 0.18)',
                background: active
                    ? 'rgba(29, 175, 161, 0.07)'
                    : 'transparent',
                borderRadius: '7px',
                padding: '13px 14px',
                marginBottom: '10px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
            }}
        >
            <div className="d-flex justify-content-between align-items-start">
                <div style={{ paddingRight: '10px' }}>
                    <div
                        className="d-flex align-items-center flex-wrap"
                        style={{ gap: '6px' }}
                    >
                        <span
                            style={{
                                color: '#FFF',
                                fontSize: '0.85rem',
                                fontWeight: 600,
                            }}
                        >
                            {title}
                        </span>

                        <span
                            style={{
                                color: '#FFF',
                                background: 'rgba(255,255,255,0.08)',
                                borderRadius: '4px',
                                padding: '2px 6px',
                                fontSize: '0.68rem',
                                fontWeight: 600,
                            }}
                        >
                            {coin}
                        </span>

                        {title === 'Order by Value' && (
                            <span
                                style={{
                                    color: '#fff',
                                    background: '#1DAFA1',
                                    borderRadius: '3px',
                                    padding: '2px 5px',
                                    fontSize: '0.58rem',
                                    fontWeight: 700,
                                }}
                            >
                                NEW
                            </span>
                        )}
                    </div>

                    <div
                        style={{
                            color: '#92969F',
                            fontSize: '0.72rem',
                            lineHeight: '1.5',
                            marginTop: '6px',
                        }}
                    >
                        {description}
                    </div>
                </div>

                {/* Radio */}
                <div
                    style={{
                        width: '17px',
                        height: '17px',
                        minWidth: '17px',
                        borderRadius: '50%',
                        border: active
                            ? '2px solid #1DAFA1'
                            : '2px solid #666',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '2px',
                    }}
                >
                    {active && (
                        <div
                            style={{
                                width: '7px',
                                height: '7px',
                                borderRadius: '50%',
                                background: '#1DAFA1',
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default function OrderPlacementPreferences({
    open,
    handleClose,
    orderBy,
    setOrderBy,
    baseCoin,
    quoteCoin,
}) {
    const [selectedOrderBy, setSelectedOrderBy] = React.useState(orderBy);
    React.useEffect(() => {
        if (open) {
            setSelectedOrderBy(orderBy);
        }
    }, [open, orderBy]);

    const handleConfirm = () => {
        setOrderBy(selectedOrderBy);
        handleClose();
        // localStorage.setItem('futuresPreferences', selectedOrderBy);
    };

    const handleCancel = () => {
        setSelectedOrderBy(orderBy);
        handleClose();
    };

    return (
        <BootstrapDialog
            onClose={handleCancel}
            aria-labelledby="order-placement-preferences-title"
            open={open}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle
                sx={{ m: 0, p: 2 }}
                id="order-placement-preferences-title"
            >
                Order Placement Preferences
            </DialogTitle>

            <IconButton
                aria-label="close"
                onClick={handleCancel}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent dividers>
                <div className="mb-2">
                    <PreferenceOption
                        active={selectedOrderBy === 'base'}
                        title="Order by Qty"
                        coin={baseCoin}
                        description={`Please enter your order qty denominated in ${baseCoin} terms.`}
                        onClick={() => setSelectedOrderBy('base')}
                    />

                    <PreferenceOption
                        active={selectedOrderBy === 'quote'}
                        title="Order by Value"
                        coin={quoteCoin}
                        description="Please enter your desired order value. You can modify the required margin by adjusting the applied leverage."
                        onClick={() => setSelectedOrderBy('quote')}
                    />
                </div>
            </DialogContent>

            <DialogActions>
                <button
                    className="btn-cancel"
                    onClick={handleCancel}
                >
                    Cancel
                </button>

                <button
                    className="btn-confirm"
                    onClick={handleConfirm}
                >
                    Confirm
                </button>
            </DialogActions>
        </BootstrapDialog>
    );
}